import React from "react";

const QuoteQuestionsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#7876A1]/50 p-3 font-instrument"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="quote-questions-title"
        className="relative rounded-2xl shadow-2xl overflow-hidden font-instrument flex flex-col items-center text-center px-6"
        style={{ width: "328px", background: "#F6F6F6", borderRadius: "16px" }}
      >
        {/* Close button (top-left) */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          aria-label="Close modal"
          className="absolute left-4 top-4 w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600"
        >
          <img src="/Vision Agent Icons/X Icon/XLightpurple.svg" alt="close" />
        </button>

        {/* Title */}
        <h2 id="quote-questions-title" className="mt-14 text-[24px] font-semibold text-[#34318C]">
          Have questions about your quote?
        </h2>

        {/* Message */}
        <p className="mt-3 text-[14px] text-[#34318C] font-normal leading-[20px] w-full text-center">
          Our AI estimates are designed to be highly accurate, but every move is unique. If anything doesn&apos;t look right, call us at 825-305-5300 and our team can review it with you.
        </p>

        {/* Action button */}
        <div className="flex justify-center items-center mt-6 w-full pb-5">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            aria-label="Got it"
            className="w-full bg-[#34318C] text-white h-[48px] rounded-[15px] font-semibold text-[14px] shadow-sm hover:bg-[#2d2a6b] focus:outline-none focus:ring-2 focus:ring-[#34318C]/30"
            style={{ maxWidth: "280px" }}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuoteQuestionsModal;
